var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { withDefaults, defaults } from "./types/config";
import { ifSetAndEnabled, forceSecure } from "./util/index";
import { validate as uuidValidate, version, v4 } from "uuid";
import { newTracker } from "@snowplow/browser-tracker";
import { PerformanceTimingPlugin } from "@snowplow/browser-plugin-performance-timing";
import { LinkClickTrackingPlugin, enableLinkClickTracking, } from "@snowplow/browser-plugin-link-click-tracking";
import { ClientHintsPlugin } from "@snowplow/browser-plugin-client-hints";
import { DebuggerPlugin } from "@snowplow/browser-plugin-debugger";
import { enableFingerprints, FingerprintPlugin } from "./fingerprint";
import { OptimizelyXPlugin } from "@snowplow/browser-plugin-optimizely-x";
import { OptimizelyPlugin } from "@snowplow/browser-plugin-optimizely";
import { GaCookiesPlugin } from "@snowplow/browser-plugin-ga-cookies";
import { SiteTrackingPlugin } from "@snowplow/browser-plugin-site-tracking";
import { buildSelfDescribingEvent, buildSiteSearch, } from "@snowplow/tracker-core";
import { enableFullStory, FullStoryPlugin, identifyFullStoryUser, } from "./fullstory";
var DEFAULT_CROSS_DOMAIN_CSS_CLASS = "trx-xd";
var ZipAnalytics = (function () {
    function ZipAnalytics(state) {
        var _this = this;
        this.currentCorrelationId = null;
        this.temporaryCorrelationId = null;
        this.newCorrelationId = function () {
            if (_this.temporaryCorrelationId) {
                _this.currentCorrelationId = _this.temporaryCorrelationId;
                _this.temporaryCorrelationId = null;
                return _this.currentCorrelationId;
            }
            _this.currentCorrelationId = v4();
            return _this.currentCorrelationId;
        };
        this.correlationId = function () {
            if (!_this.state.trackCorrelationId)
                console.error("[zip-analytics-js] correlation id is disabled but application is calling .correlationId()");
            if (_this.currentCorrelationId)
                return _this.currentCorrelationId;
            if (!_this.temporaryCorrelationId)
                _this.temporaryCorrelationId = v4();
            return _this.temporaryCorrelationId;
        };
        this.page = function (data) {
            var _a;
            return Promise.resolve(_this.state.tracker.trackPageView(_this.state.trackCorrelationId
                ? __assign(__assign({}, data), { context: __spreadArray(__spreadArray([], __read(((_a = data === null || data === void 0 ? void 0 : data.context) !== null && _a !== void 0 ? _a : []))), [
                        {
                            schema: "iglu:co.zip.common/correlation_context/jsonschema/1-0-0",
                            data: {
                                correlation_id: _this.newCorrelationId(),
                            },
                        },
                    ]) }) : data));
        };
        this.trackEvent = function (payload, context) {
            return Promise.resolve(_this.state.tracker.core.track(buildSelfDescribingEvent({ event: payload }), context));
        };
        this.identify = function (userId) {
            return Promise.resolve(_this.state.tracker.setUserId(userId));
        };
        this.trackSearch = function (payload) {
            return Promise.resolve(_this.state.tracker.core.track(buildSiteSearch(payload), payload.context));
        };
        this.setGlobalContexts = function (contexts) {
            return Promise.resolve(_this.state.tracker.core.addGlobalContexts(contexts));
        };
        this.state = state;
    }
    return ZipAnalytics;
}());
var validateOptions = function (opts) {
    if (!opts.appInfo) {
        throw new Error("App info is missing");
    }
    if (!uuidValidate(opts.appInfo.id) || version(opts.appInfo.id) != 4) {
        throw new Error("App ID needs to be a v4 uuid");
    }
    if (!opts.appInfo.namespace || opts.appInfo.namespace === "") {
        throw new Error("App namespace is required");
    }
    if (!opts.snowplowJsUrl || opts.snowplowJsUrl == "") {
        throw new Error("URL to load sp.js from is not specified");
    }
    if (!opts.collectorEndpoint || opts.collectorEndpoint == "") {
        throw new Error("Collector endpoint is not specified");
    }
};
var createAnalytics = function (o) {
    var _a;
    var opts = Object.assign({}, defaults, o);
    validateOptions(opts);
    (function (p, l, o, w, i, n, g) {
        if (!p[i]) {
            p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
            p.GlobalSnowplowNamespace.push(i);
            p[i] = function () {
                (p[i].q = p[i].q || []).push(arguments);
            };
            p[i].q = p[i].q || [];
            n = l.createElement(o);
            g = l.getElementsByTagName(o)[0];
            n.async = 1;
            n.src = w;
            g.parentNode.insertBefore(n, g);
        }
    })(window, document, "script", opts.snowplowJsUrl, "snowplow");
    var tracker = newTracker(opts.appInfo.namespace, forceSecure(opts.collectorEndpoint), {
        appId: (_a = opts.appInfo) === null || _a === void 0 ? void 0 : _a.id,
        anonymousTracking: opts.anonymousTracking
            ? { withServerAnonymisation: true, withSessionTracking: true }
            : undefined,
        contexts: {
            webPage: true,
        },
        stateStorageStrategy: opts.anonymousTracking
            ? "none"
            : "cookieAndLocalStorage",
        postPath: "/z/t",
        discoverRootDomain: true,
        cookieSecure: true,
        plugins: [
            PerformanceTimingPlugin(),
            LinkClickTrackingPlugin(),
            ClientHintsPlugin(),
            SiteTrackingPlugin(),
        ],
    });
    tracker.setReferrerUrl(document.referrer);
    if (opts.debug) {
        tracker.addPlugin({ plugin: DebuggerPlugin() });
    }
    var fpjs = opts.fpjs, pageTracking = opts.pageTracking, optimizely = opts.optimizely, ga = opts.ga, crossDomain = opts.crossDomain, fullStory = opts.fullStory;
    if (pageTracking && pageTracking.enabled) {
        var linkClickTracking = pageTracking.linkClickTracking, activityTracking = pageTracking.activityTracking;
        ifSetAndEnabled(linkClickTracking)(function (linkClickTracking) {
            enableLinkClickTracking({
                trackContent: linkClickTracking.trackContent,
                options: {
                    filter: linkClickTracking.filter,
                    allowlist: linkClickTracking.allowlist,
                    denylist: linkClickTracking.denylist,
                },
                pseudoClicks: true,
            }, [tracker.id]);
        });
        ifSetAndEnabled(activityTracking)(function () {
            tracker.enableActivityTracking({
                minimumVisitLength: 15,
                heartbeatDelay: 15,
            });
        });
    }
    ifSetAndEnabled(optimizely)(function (optimizely) {
        var x = optimizely.x, classic = optimizely.classic;
        ifSetAndEnabled(x)(function () {
            tracker.addPlugin({ plugin: OptimizelyXPlugin() });
        });
        ifSetAndEnabled(classic)(function (classic) {
            tracker.addPlugin({
                plugin: OptimizelyPlugin(classic.summary, classic.experiments, classic.states, classic.variations, classic.visitor, classic.audiences, classic.dimensions),
            });
        });
    });
    ifSetAndEnabled(ga)(function () {
        tracker.addPlugin({ plugin: GaCookiesPlugin() });
    });
    ifSetAndEnabled(crossDomain)(function (crossDomain) {
        tracker.crossDomainLinker(function (el) {
            return el.classList.contains(crossDomain.cssClass || DEFAULT_CROSS_DOMAIN_CSS_CLASS);
        });
    });
    ifSetAndEnabled(fullStory)(function (fullStory) {
        tracker.addPlugin({ plugin: FullStoryPlugin() });
        enableFullStory(fullStory, [tracker.id]);
    });
    ifSetAndEnabled(fpjs)(function (fpjs) {
        if (fpjs.ossEnabled || fpjs.proEnabled) {
            tracker.addPlugin({ plugin: FingerprintPlugin() });
            enableFingerprints(fpjs, [tracker.id]);
        }
    });
    return new ZipAnalytics({
        tracker: tracker,
        trackCorrelationId: !!opts.correlationId,
    });
};
export { withDefaults, identifyFullStoryUser, DEFAULT_CROSS_DOMAIN_CSS_CLASS, };
export default createAnalytics;
